module.exports = __webpack_public_path__ + "img/fyzx.078fa13e.svg";